import './index.less';

import { Button } from '@bfe/moly';
import { TerminateIcon } from '@bfe/moly-icons';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';

import DeleteAccountUnableReasonModal from './DeleteAccountUnableReasonModal';
import useDeleteAccountPrecheck from './useDeleteAccountPrecheck';

const DeleteAccount = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();

  const {
    preChecking,
    precheck,
    businessUnitDetails,
    constants,
    showErrorsModal,
    closeShowErrorsModal,
  } = useDeleteAccountPrecheck();

  const handleDeleteBtn = () => {
    precheck({
      onPass: () => {
        navigate('/app/user/delete-account');
      },
    });
  };

  return (
    <>
      <AccountBasicItem
        icon="deleteAccount"
        molyIcon={<TerminateIcon />}
        text={$t('deleteAccount')}
        subText={$t('deleteAccountDesc')}
        operation={
          <>
            <Button
              onClick={() => handleDeleteBtn()}
              size="small"
              data-radius="small"
              variant="secondary"
              disabled={preChecking}
              loading={preChecking}
            >
              {$t('delete')}
            </Button>
          </>
        }
      />
      <DeleteAccountUnableReasonModal
        businessUnitDetails={businessUnitDetails}
        visible={showErrorsModal}
        constants={constants}
        onClose={closeShowErrorsModal}
      />
    </>
  );
};

export default DeleteAccount;
